import {
  categoriesToHierarchy,
  ClassifierValidFormDataType,
} from '@atlas-frontend/sdk';
import { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';

export const useSyncHierarchy = () => {
  const { getValues, setValue } = useFormContext<ClassifierValidFormDataType>();
  return useCallback(
    () => setValue('hierarchy', categoriesToHierarchy(getValues('categories'))),
    [setValue, getValues]
  );
};
